// 9fbef606107a605d69c0edbcd8029e5d
import React from 'react';
import PropTypes from 'prop-types';
import { NextSeo } from 'next-seo';

const SEO = ({ title, description, ...otherProps }) => {
  return <NextSeo title={title} description={description} {...otherProps} />;
};

SEO.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
};

SEO.defaultProps = {
  title: '',
  description: '',
};

export default SEO;
